import React, { useState, useEffect } from "react";
import { Row, Col, Form, FormGroup, Label, Input } from "reactstrap";
import { addWaitlister } from "../api"; // Adjust the path as needed

const WaitlistForm = () => {
  const [formData, setFormData] = useState({ name: "", email: "" });
  const [message, setMessage] = useState("");
  const [selectedExperiment, setSelectedExperiment] = useState(null);

  const experiments = [
    {
      waitlist_version: 1,
      waitlist_name: "smallties",
      header: "Groceries, Goods, and Goodwill",
      subheader:
        "Conveniently shop for your essentials while supporting small businesses.",
      CTA: "Notify me when I can start shopping.",
    },
    {
      waitlist_version: 2,
      waitlist_name: "smallties",
      header: "Turn Everydayzz Purchases into Local Impact",
      subheader: "One cart, countless small business owners supported.",
      CTA: "Notify me when the small business market opens!",
    },
    {
      waitlist_version: 3,
      waitlist_name: "smallties",
      header: "Shop Where Your Dollars Make a Difference",
      subheader:
        "Your everyday needs, delivered exclusively by small businesses.",
      CTA: "Notify me when I can get started!",
    },
  ];

  // Load the experiment on component mount
  useEffect(() => {
    const persistedExperiment = localStorage.getItem("selectedExperiment");
    if (persistedExperiment) {
      setSelectedExperiment(JSON.parse(persistedExperiment));
    } else {
      const randomExperiment =
        experiments[Math.floor(Math.random() * experiments.length)];
      localStorage.setItem(
        "selectedExperiment",
        JSON.stringify(randomExperiment)
      );
      setSelectedExperiment(randomExperiment);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = {
        name: formData.name,
        email: formData.email,
        waitlist_version: selectedExperiment?.waitlist_version, // Use selected experiment version
        waitlist_name: selectedExperiment?.waitlist_name, // Use selected experiment name
      };
      await addWaitlister(data); // Replace with your actual API call
      setMessage("You have been added to the waitlist!");
      setFormData({ name: "", email: "" });
    } catch (error) {
      setMessage("There was an error. Please try again.");
    }
  };

  return (
    <React.Fragment>
      <Form
        method="post"
        name="contact-form"
        id="contact-form"
        onSubmit={handleSubmit}
      >
        <Row>
          <Col sm={12} lg={6}>
            <FormGroup className="mt-3">
              <Label className="contact-label">Name</Label>
              <Input
                name="name"
                id="name"
                className="form-control"
                type="text"
                value={formData.name}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>
          <Col sm={12} lg={6}>
            <FormGroup className="mt-3">
              <Label className="contact-label">Email</Label>
              <Input
                name="email"
                id="email"
                className="form-control"
                type="text"
                value={formData.email}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={12} className="mt-3 text-right">
            <Input
              id="submit"
              name="send"
              color="primary"
              className="submitBnt btn btn-primary btn-round"
              value={selectedExperiment ? selectedExperiment.CTA : "Loading..."}
              type="submit"
              style={{ width: "100%", color: "#fff" }}
            />
            <div id="simple-msg">{message}</div>
          </Col>
        </Row>
      </Form>
    </React.Fragment>
  );
};

export default WaitlistForm;
